import * as R from 'ramda'
import React, { Fragment, useState, useEffect } from 'react'
import G from '../util/globalFunction'
import qs from 'qs'
import Layout from '../layout'
import { defaultKeywords } from '../config'
import { dynamicRoutePages } from '../dynamicPageMap'

export default (option = {}) =>
    WrappedComponent =>
    props => {
        const [mediaSize, setMediaSize] = useState(G.getMediaSize())
        let {
            layout: optionLayout,
            layoutMode,
            title,
            keywords: optionKeywords,
            pageMode: optionContainMode,
        } = option
        const {
            location: { pathname, search, state },
            params: origParams,
            path,
            mode,
        } = props
        
        //layout은 선언되지 않으면 보이도록
        const layout = R.isNil(optionLayout) || optionLayout

        const passUrl = path === '/redirectPrev/'

        // page에 타이틀이 선언되지 않으면 오류 처리
        if (!title) {
            throw new Error(`page title 설정 오류 : ${JSON.stringify(path)}`)
        }
        //keywords는 기본 keywords에 추가되어 설정
        let keywords = !optionKeywords
            ? [...defaultKeywords]
            : Array.isArray(optionKeywords)
            ? [...defaultKeywords, ...optionKeywords]
            : [...defaultKeywords, `${optionKeywords}`]

        // container 모드 : 기본은 추가 find 임
        // find : page 위치를 찾아 이동 기존 화면을 그대로 보여줌
        // new : 새로운 page로 추가
        // state의 mode로 설정되어 있으면 변경하기 때문에 let으로 정의
        let containMode = !mode ? (!optionContainMode ? 'find' : optionContainMode) : mode

        //파라미터 처리 dynamic Routing, query string, post string, navigate의 state를 모두 params로 만듬
        const params = { '*': origParams['*'] }
        const addParam = (name, value) =>
            !params[name]
                ? (params[name] = value)
                : Array.isArray(params[name])
                ? params[name].push(value)
                : (params[name] = [params[name], value])

        //dynamic Routing 처리
        for (const { uri, paramNames } of dynamicRoutePages) {
            if (pathname.substr(0, uri.length) === uri) {
                const values = String(origParams['*']).split('/')
                for (let i = 0; i < paramNames.length; i++) {
                    addParam(paramNames[i], values[i] || null)
                }
                break
            }
        }
        //QueryString 처리
        if (search.length !== 0) {
            const q = qs.parse(search.substring(1))
            for (const name in q) {
                addParam(name, q[name])
            }
        }
        //navigate의 state로 넘어온 파라미터 추가
        if (state) {
            for (const name in state) {
                name !== 'key' && addParam(name, state[name])
            }
            const { pageMode } = state
            containMode = !pageMode ? containMode : pageMode
        }

        useEffect(() => {
            const sizer = () => {
                setMediaSize(G.getMediaSize())
            }
            window.addEventListener('resize', sizer)
            return () => {
                window.removeEventListener('resize', sizer)
            }
        }, [])

        ///파라미터 만들기
        const parm = { ...props, params }

        const layoutProps = {
            title,
            keywords,
            mode: containMode,
            layoutMode,
            layout,
            passUrl,
            parm,
        }

        return (
            <Layout {...layoutProps}>
                <WrappedComponent {...parm} mediaSize={mediaSize} />
            </Layout>
        )
    }
